/** Code scanné nettoyé : espaces, retours et caractères de contrôle retirés. */
export const cleanScannedCode = (raw: string): string =>
  [...raw]
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 0x20 && code !== 0x7f && !/\s/.test(char);
    })
    .join('');
